import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { SelectedStylepackContext } from '../stylepack-context';
import styles from '../stylepacks.module.css';
import { formatMsToHMMSS } from '@/utils/dates';
import type { GraphicItem } from './video-list-graphic.types';

export default function VideoListItem(video: GraphicItem) {
  const { stylepack } = useContext(SelectedStylepackContext);

  return (
    <Container
      width="100%"
      padding="8px 16px 8px 8px"
      borderRadius="8px"
      className={`cursor-pointer ${styles.listItem}`}
      background="rgba(255, 255, 255, 0.05)"
      hoverBackground="rgba(255, 255, 255, 0.10)"
    >
      <Container className="flex flex-column jc-center">
        <img src={video.thumbnailUrl} className="radius-8 width-72 height-40" />
      </Container>
      <Container className="flex flex-column jc-center">
        <Text className="S2" design={video.name !== 'Untitled' ? 'GlobalIcoText1' : 'GlobalIcoText2'}>
          {video.shotTitle ?? stylepack.name}
        </Text>
        <Text design="GlobalIcoText4" className="L2" transform="capitalize">
          {video.contentType}
        </Text>
      </Container>
      <Container className="flex ai-center">
        <Text className="S2" design={'GlobalIcoText3'}>
          {video.shotTitle}
        </Text>
      </Container>
      <Container className="flex ai-center">
        <Text design="GlobalIcoText3" className="L2">
          {formatMsToHMMSS((video.duration ?? 0) * 1000)}
        </Text>
      </Container>
      <Container className={`flex ai-center jc-flex-end ${styles.listItemActions}`}>
        <Link to={`./preview/greenroom`} relative="path" state={{ videoId: video.id }}>
          <Button design="LocalBttnPrim" designSize="small">
            Preview
          </Button>
        </Link>
      </Container>
    </Container>
  );
}
